export interface OutboundFreshdeskReceipt {
  id: number | string;
  private: boolean;
  incoming: false;
  created_at?: unknown;
  deleted?: boolean | null;
}

/** Provider evidence must establish the requested audience and outbound direction.
 * Missing or unknown flags cannot be rewritten from the compose request. */
export function isConfirmedOutboundFreshdeskReceipt(note: unknown, expectedPrivate: boolean): note is OutboundFreshdeskReceipt {
  if (!note || typeof note !== 'object') return false;
  const row = note as Record<string, unknown>;
  const validId = (typeof row.id === 'number' || typeof row.id === 'string')
    && /^[1-9]\d*$/.test(String(row.id)) && Number.isSafeInteger(Number(row.id));
  return validId && row.private === expectedPrivate && row.incoming === false
    && (row.deleted === false || row.deleted == null);
}

/** Keep an exact, valid timezone-qualified provider event time. Date.parse alone
 * accepts impossible dates such as February 30 by rolling into the next month. */
export function validatedFreshdeskEventTime(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/.exec(value);
  if (!parts) return null;
  const [, year, month, day, hour, minute, second] = parts.map(Number);
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  if (month < 1 || month > 12 || day < 1 || day > days[month - 1] || hour > 23 || minute > 59 || second > 59 || !Number.isFinite(Date.parse(value))) return null;
  return value;
}
